import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { UserService } from 'app/_services/user.service';

declare const isEmpty: any;

@Injectable({ providedIn: 'root' })
export class BuyerDashboardService extends BaseService {
    private _domain: string = '/buyer/dashboard';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public backToSupport(quotation_id: number, reason: string): Observable<any> {
        return this.config.executePost({ url: `${this._domain}/quotation/${quotation_id}/back-to-support`, body: { reason } });
    }

    public deleteQuotation(quotation_id: number, reason_id: number, comment: string): Observable<any> {
        let body: any = {
            reason_id,
            comment
        };

        return this.config.executeDelete({ url: `${this._domain}/quotation/${quotation_id}`, body });
    }

    public getAllQuotations(includeReviews: boolean): Observable<any> {
        const buyerCompanyId = this.userService.userCompanyId();
        return this.config.executeGet({ url: `${this._domain}/${buyerCompanyId}?includeReviews=${includeReviews}` });
    }
}
